import './index.scss'

import { Controller as BaseController } from 'stimulus'
import { getCollapsedState, setCollapsedState } from '@app/javascript/classes/collapsibleCard'
import Rails from '@rails/ujs'

export class Controller extends BaseController {
  static targets = ['self', 'icon', 'content', 'form']
  static classes = ['collapsed', 'responsiveEditCta']
  static values = {
    cardTitle: String,
    responsiveEditCta: Boolean
  }

  connect() {
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('h-transform-rotate-180', this.collapsed)
    }

    this.selfTarget.classList.toggle(this.collapsedClass, !!this.collapsed)

    if (this.responsiveEditCtaValue) {
      this.handleResize()
    }

    $(this.contentTarget).find('a').filter(':not([class])').each(function() {
      $(this).attr('target', '_blank')
    })

    $(this.contentTarget).find('a[target=_blank]').filter(':not([class])').each(function() {
      $(this).attr('target', '_blank').addClass('external_link_content')
    })
  }

  submitForm() {
    Rails.ajax({
      type: this.formTarget.method,
      url: this.formTarget.action,
      dataType: 'script',
      data: $(this.formTarget).serialize()
    })
  }

  toggle() {
    this.collapsed = !this.collapsed
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('h-transform-rotate-180')
    }
    this.selfTarget.classList.toggle(this.collapsedClass)
  }

  get collapsed() {
    return getCollapsedState(this.cardTitleValue)
  }

  set collapsed(value) {
    return setCollapsedState(this.cardTitleValue, value)
  }

  handleResize() {
    this.selfTarget.classList.toggle(this.responsiveEditCtaClass, this.selfTarget.scrollWidth < 700)
  }
}
